export function useAutocomplete(getAvailable, getDirs) {
  function tokenizeUsage(u) {
    return (u || '').trim().split(/\s+/).filter(Boolean)
  }

  function buildUsageMatrix() {
    const matrix = []
    const available = getAvailable()
    available.forEach((c) => {
      const u = (c.usage || c.name || '').trim()
      if (!u) return
      matrix.push(tokenizeUsage(u))
    })
    matrix.push(['cd', '<dir>'])
    return matrix
  }

  function longestCommonPrefix(strings) {
    if (!strings.length) return ''
    let p = strings[0]
    for (let s of strings.slice(1)) {
      let i = 0
      while (i < p.length && i < s.length && p[i] === s[i]) i++
      p = p.slice(0, i)
      if (!p) break
    }
    return p
  }

  function tryAutocomplete(current) {
    const v = current || ''
    const endsSpace = /\s$/.test(v)
    const trimmed = v.trimEnd()
    const toks = trimmed ? trimmed.split(/\s+/) : []
    const pos = endsSpace ? toks.length : Math.max(0, toks.length - 1)
    const partial = endsSpace ? '' : (toks[toks.length - 1] || '')

    const matrix = buildUsageMatrix()
    let candidates = []

    const dirs = getDirs()
    if ((toks[0] || '') === 'cd' && pos === 1) {
      candidates = (dirs || []).map(String)
    } else {
      matrix.forEach((utoks) => {
        if (utoks.length <= pos) return
        for (let i = 0; i < pos; i++) {
          const ut = utoks[i]
          const it = toks[i]
          const isParam = /^<[^>]+>$/.test(ut)
          if (!isParam && ut !== it) return
        }
        const target = utoks[pos]
        const isParam = /^<[^>]+>$/.test(target)
        if (!isParam) candidates.push(target)
      })
    }
    candidates = Array.from(new Set(candidates)).filter(c => c.startsWith(partial))
    if (!candidates.length) return v

    let insert = ''
    if (candidates.length === 1) {
      insert = candidates[0]
    } else {
      const lcp = longestCommonPrefix(candidates)
      if (lcp.length > partial.length) insert = lcp
      else return v
    }
    if (endsSpace) toks.push(insert)
    else toks[toks.length - 1] = insert
    return toks.join(' ') + ' '
  }

  return { tryAutocomplete }
}

